var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "#EDEDED",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12L3.36846 10.8304C3.84402 10.4222 4.63661 10.4026 5.14173 10.7869C5.15695 10.7992 5.98089 11.4772 5.98089 11.4772C6.47795 11.8869 7.29025 11.8934 7.79625 11.4917C7.82939 11.4656 9.88656 9.44547 9.88656 9.44547C10.4167 8.92412 11.3688 8.84944 12.0136 9.27942C12.0566 9.30843 14 10.9232 14 10.9232",
    stroke: "#130F26",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19286 5.31909C6.19286 6.12659 5.5387 6.78076 4.7312 6.78076C3.9237 6.78076 3.26953 6.12659 3.26953 5.31909C3.26953 4.51159 3.9237 3.85742 4.7312 3.85742C5.5387 3.85826 6.19286 4.51159 6.19286 5.31909Z",
    stroke: "#130F26",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.8a23250250758ae4972007891baa2ddd.svg";
export { ForwardRef as ReactComponent };